/* eslint-disable */

/**
 *
 * Required translation strings:
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("bundle-child-variant-picker")) {
  class BundleChildVariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      // this.dispatchEvent(new CustomEvent("on:child-variant:load", { bubbles: true }));
    }

    init() {
      this.bundles = window.theme.relevantBundles || [];
      this.bundle = null;
      this.section = this.closest(".js-bundle-child-wrapper");
      this.optionSelectors = this.querySelectorAll(".option-selector");
      this.inputs = this.querySelectorAll(".js-option");
      this.data = this.getProductData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.optionsModal = null;
      this.mobileSelectors = this.querySelectorAll(".opt-label--select");
      this.mobileListenersActive = false;
      this.mobileResize = this.mobileResizeListener.bind(this);
      this.primaryOptionName = this.getPrimaryOptionName();
      this.primaryOptionValuesWithFrom = this.dataset.primaryOptionValuesWithFrom?.split(",") || [];
      this.setSelectedOptionLabels(this.inputs);
      this.updateAvailability();
      this.setBundle();
      this.inputs.forEach(input => {
        input.addEventListener("change", this.handleOptionSelection.bind(this));
      })
      document.addEventListener("on:variant:change", this.handleParentVariantChange.bind(this));

      if (this.mobileSelectors.length) {
        this.optionsModal = document.getElementById("options-modal");

        if (matchMedia("(max-width: 767px)").matches) {
          this.addMobileListeners();
        }
        
        addEventListener("resize", () => {
          if (this.mobileListenersActive && matchMedia("(min-width: 768px)").matches) {
            this.removeMobileListeners();
          } else if (!this.mobileListenersActive && matchMedia("(max-width: 767px)").matches) {
            this.addMobileListeners();
          }
        });
        
        this.optionsModal.addEventListener("click", this.handleModalClick.bind(this));
      }

      this.dispatchEvent(new CustomEvent("on:child-variant:load", { bubbles: true }));
    }

    setBundle() {
      if (!this.bundles?.length) return;
      
      const matchingBundle = this.bundles.find(b => b.id === this.section.dataset.bundleId);

      if (matchingBundle) {
        this.bundle = matchingBundle;
      }
    }

    handleModalClick(e) {
      if (e.target.id === "options-modal") {
        this.hideOptionsModal();
      }
    }

    handleModalOptionClick(e) {
      const clicked = e.target;

      if (!clicked || clicked.dataset.unavailable === "true") return;

      const clickedId = clicked.getAttribute("for");
      
      if (clickedId) {
        const nextInput = this.querySelector(`input#${clickedId}`);
        const modalSelectorButtons = clicked.closest(".option-selector__btns");
        const prevSelected = modalSelectorButtons.querySelector(`[data-selected="true"]`);
        
        if (nextInput) {
          const selectorButtons = nextInput.closest(".option-selector__btns");
          const prevItem = selectorButtons.querySelector('[data-visible="true"]');

          if (prevItem) {
            prevItem.removeAttribute("data-visible");
            prevItem.querySelector("input").removeAttribute("checked");
          }

          nextInput.checked = "true";
          nextInput.closest(".js-opt-wrapper").dataset.visible = "true";
          clicked.dataset.selected = "true";
          
          this.selectedOptions = this.getSelectedOptions();
          this.variant = this.getSelectedVariant();
          this.hideOptionsModal();

          this.setSelectedOptionLabels([nextInput]);
          this.dispatchEvent(new CustomEvent("on:child-variant:change", { bubbles: true }));
        }

        if (prevSelected) {
          prevSelected.removeAttribute("data-selected");
        }
      }
    }

    showOptionsModal(clickedEl) {
      const selectorButtons = clickedEl.closest(".option-selector__btns");
      const buttons = selectorButtons.querySelectorAll("label");

      buttons.forEach(button => {
        const cloned = button.cloneNode(true);
        const secondaryEl = cloned.querySelector('.opt-label__secondary');
        const label = secondaryEl?.dataset.label || null;
        const unavailable = cloned.querySelector('[data-unavailable]');

        if (label === "Out Of Stock") {
          cloned.dataset.oos = "true";
        }

        if (unavailable) {
          cloned.dataset.unavailable = "true";
        }

        cloned.classList.remove("opt-label--select");
        cloned.removeChild(cloned.querySelector(".opt-label__chevron"));

        if (clickedEl.getAttribute("for") === cloned.getAttribute("for")) {
          cloned.dataset.selected = "true";
        }

        this.optionsModal.querySelector(".option-selector__btns").appendChild(cloned);

        cloned.addEventListener("click", this.handleModalOptionClick.bind(this));
      });

      this.optionsModal.dataset.visible = "true";
      document.body.dataset.fixed = "true";
    }

    hideOptionsModal() {
      document.body.dataset.fixed = "false";
      this.optionsModal.dataset.visible = "false";

      setTimeout(() => {
        this.optionsModal.querySelector(".option-selector__btns").innerHTML = "";
      }, 200);
    }

    addMobileListeners() {
      this.mobileListenersActive = true;

      this.mobileSelectors.forEach(selector => {
        selector.addEventListener("click", this.mobileResize);
      });

      // Make sure selected option is visible
      const selectors = this.querySelector('[mobile-selectors]');
      const visibleSelector = selectors.querySelector('[data-visible="true"]');
      const visibleInput = visibleSelector?.querySelector('input:checked');

      if (visibleInput) return;

      const checkedInput = selectors.querySelector(`input:checked`);
      
      if (checkedInput) {
        visibleSelector.dataset.visible = "false";
        checkedInput.closest(".js-opt-wrapper").dataset.visible = "true";
      }
    }

    removeMobileListeners() {
      this.mobileListenersActive = false;
      this.hideOptionsModal();

      
      this.mobileSelectors.forEach(selector => {
        selector.removeEventListener("click", this.mobileResize);
      });
    }

    mobileResizeListener(e) {
      this.showOptionsModal(e.target);
    }

    setSelectedOptionLabels(inputs) {
      inputs.forEach(input => {

        if (!input.checked) return;
        
        const bundleChildContainer = input.closest('.option-selector');
        const optionLabelEl = bundleChildContainer.querySelector('[data-selected-option]');
        const clearanceLabelEl = bundleChildContainer.querySelector('[data-selected-clearance-option]');
        const isClearance = input.dataset.clearance === "true";
        const isDecline = input.value === "DECLINE";
        
        if (optionLabelEl) {
          optionLabelEl.innerHTML = (isClearance || isDecline) ? 'None selected' : input.value;
        }

        if (clearanceLabelEl) {
          clearanceLabelEl.innerHTML = isClearance ? input.value : 'None selected';
        }
      })
    }

    handleOptionSelection(e) {
      const input = e.target;
      const isPrimary = this.primaryOptionName ? input.dataset.optionName === this.primaryOptionName : true;
      const optionSelector = input.closest(".option-selector");
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant(isPrimary && this.selectedOptions.length > 1, Number(optionSelector?.dataset.selectorIndex || 0));

      // Update currently selected option label
      this.setSelectedOptionLabels([input]);

      if (this.optionSelectors?.length > 1 && isPrimary) {
        this.updateAvailability();
        
        if (this.variant) {
          this.selectCurrentVariant();
        }
      }

      this.updatePricing();

      this.dispatchEvent(new CustomEvent("on:child-variant:change", { bubbles: true }));
    }

    updatePricing() {
      if (!this.bundle || !this.variant) return;
      // if (this.bundle) return;

      const price = this.variant.price;
      const compareAtPrice = this.variant.compare_at_price;
      const regularPrice = compareAtPrice > price ? compareAtPrice : price;
      const config = this.bundle.configs.find(c => c.targets.find(t => {
        if (t.vids?.length) {
          return t.vids.includes(this.variant.id)
        } else {
          return t.pid === String(this.data.product.id)
        }
      }));

      if (!config) return;

      const discountMultiplier = (100 - (config.percent || 0)) * 0.01;
      const discountedPrice = regularPrice * discountMultiplier;
      const parentContainer = this.closest('[data-bundle-child]');
      const priceEl = parentContainer.querySelector('[data-price]');

      if (priceEl) {
        priceEl.innerHTML = `$${(discountedPrice * 0.01).toFixed(2)}`;

        if (regularPrice > discountedPrice) {
          const compareAtEl = parentContainer.querySelector('[data-compare-at]');

          if (compareAtEl) {
            compareAtEl.innerHTML = `$${(regularPrice * 0.01).toFixed(2)}`;
          }
        }
      }
    }

    /**
     * Handles "on:variant:change" events on the parent variant picker element.
     * @param {object} e - Event object.
     */
    handleParentVariantChange(e) {
      this.updateVisibility(e.detail);
      this.updateAvailability();
      // this.dispatchEvent(new CustomEvent('on:child-variant:change', { bubbles: true }));
    }

    /**
     * Shows/hides relevant bundle children & their labels
     */
    updateVisibility({ variant }) {
      if (!this.bundles?.length) return;
      if (this.bundles.length === 1 && !this.bundles[0].parent.vids?.length) return;
      
      const matchingBundle = this.bundles.find(b => {
        if (!b.parent.vids?.length) {
          return true;
        } else {
          return b.parent.vids?.some(vid => vid === String(variant.id))
        }
      })

      if (matchingBundle && matchingBundle.id === this.section.dataset.bundleId) {
        this.bundle = matchingBundle;
        this.section.setAttribute('data-visible', true);
      } else {
        this.bundle = null;
        this.section.setAttribute('data-visible', false);
      }
    }

    getPrimaryOptionName() {
      const options = this.data.product.options || null;

      if (!options) return null;

      return options.includes("Size") ? "Size" : options[0];
    }

    getShowPrice({ hasMultipleOptions, isPrimaryOption, isStackChild, priceVaries }) {
      if (isStackChild) return false;
      if (!hasMultipleOptions && priceVaries) return true;
      if (hasMultipleOptions) {
        if (isPrimaryOption) return true;

        const primaryOptionHasFrom = this.primaryOptionValuesWithFrom.reduce((acc, cur) => {
          return acc || this.selectedOptions.includes(cur.trim());
        }, false);        

        return primaryOptionHasFrom;
      }
      
      return false;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    updateOptionAvailabilityAndPrice(optionEl, exists, available, price = null) {
      const isPrimaryOption = this.primaryOptionName ? optionEl.dataset.optionName === this.primaryOptionName : true;
      const hasMultipleOptions = this.selectedOptions && this.selectedOptions.length > 1;
      const isStackChild = this.dataset.type === "S";
      const showPrice = this.getShowPrice({
        hasMultipleOptions,
        isPrimaryOption,
        isStackChild,
        priceVaries: this.dataset.priceVaries === "true"
      });
      const labelEl = optionEl.nextElementSibling;
      const primaryEl = labelEl?.querySelector('.opt-label__primary');
      const secondaryEl = labelEl?.querySelector('.opt-label__secondary');
      const priceEl = primaryEl?.querySelector('.opt-label__price');

      
      if (exists) {
        optionEl.removeAttribute("disabled");
        optionEl.classList.remove('is-nonexistent');
        
        if (primaryEl) {
          primaryEl.removeAttribute('data-unavailable');
        }

        if (priceEl) {
          if (!isPrimaryOption && showPrice) {
            priceEl.innerHTML = price ? `$${(price * 0.01).toFixed(2)}` : ''
          } else if (isPrimaryOption && isStackChild) {
            priceEl.innerHTML = "";
          }
        }

        if (optionEl.value !== 'DECLINE') {
          if (available) {
            const label = labelEl ? labelEl.dataset.label : null;

            if (secondaryEl) {
              if (label) {
                secondaryEl.setAttribute('data-label', label);
              } else {
                secondaryEl.removeAttribute('data-label');
              }
            }

            optionEl.classList.remove('is-oos');
          } else {
            optionEl.classList.add('is-oos');
            
            if (secondaryEl) {
              secondaryEl.setAttribute('data-label', "Out Of Stock");
            }
          }
        }
      } else {
        optionEl.disabled = true;
        optionEl.classList.add('is-nonexistent');
        
        if (primaryEl) {
          primaryEl.setAttribute('data-unavailable', "");
          secondaryEl.removeAttribute('data-label');

          if (showPrice) {
            primaryEl.setAttribute('data-show-price', "");
          } else {
            primaryEl.removeAttribute('data-show-price');
          }
        }
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      let currVariant = this.variant || { options: this.getSelectedOptions() };

      // Set initial availability states
      const hasMultipleOptions = this.selectedOptions && this.selectedOptions.length > 1;
      this.inputs.forEach((input) => {
        const isPrimary = this.primaryOptionName ? input.dataset.optionName === this.primaryOptionName : true;
        const markAsAvailable = (hasMultipleOptions && isPrimary) || input.value === 'DECLINE';
        const exists = markAsAvailable || !hasMultipleOptions;
        this.updateOptionAvailabilityAndPrice(input, exists, markAsAvailable);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector) => {
        const selectorIndex = Number(selector.dataset.selectorIndex);
        const isPrimary = this.primaryOptionName ? selector.dataset.optionName === this.primaryOptionName : true;
        
        if (!isPrimary || !hasMultipleOptions) {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              const matches = currVariant.options.includes(option);

              if (matches && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');

              const optionEl = Array.from(options).find((opt) => {
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                const variantWithData = this.getVariantWithData(variant);
                this.updateOptionAvailabilityAndPrice(optionEl, true, variantWithData.isAvailable, variant.price);
              }
            }
          })
        }
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      let selectedOptions = new Array(this.optionSelectors.length);

      this.optionSelectors.forEach((selector) => {
        const selectorIndex = Number(selector.dataset.selectorIndex || 0);
        const inputs = selector.querySelectorAll('input');
        let selected = null;

        inputs.forEach(input => {
          if (input.checked) {
            selected = input;
          }
        });
        
        if (selected) {
          selectedOptions[selectorIndex] = selected ? selected.value : null;
        } else {
          const firstInput = selector.querySelector('input');

          if (firstInput) {
            firstInput.checked = true;
            
            selectedOptions[selectorIndex] = firstInput.value;
          }
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant(primaryOptionChanged = false, optionIndex = 0) {
      const variant = this.data.product.variants.find(
        (v) => v.options.every((val) => this.selectedOptions.includes(val))
      );

      if (!variant && primaryOptionChanged && this.selectedOptions.length) {
        const foundVariant = this.data.product.variants.sort((a, b) => { 
          let isClearanceA = false;
          let isClearanceB = false;

          for (const item of this.data.validation.clearance) {
            if (a.title.toLowerCase().includes(item)) {
              isClearanceA = true;
            }

            if (b.title.toLowerCase().includes(item)) {
              isClearanceB = true;
            }
          }

          if (isClearanceA && !isClearanceB) return 1;
          if (!isClearanceA && isClearanceB) return -1;
          return 0;
        }).find(v => v[`option${optionIndex + 1}`] === this.selectedOptions[optionIndex] && v.available);

        return foundVariant ? this.getVariantWithData(foundVariant) : this.getVariantWithData(this.data.product.variants[0]);
      }

      return this.getVariantWithData(variant);
    }

    getVariantWithData(variant) {
      const variantData = this.data.formatted[variant.id];
      const continueSelling = variantData?.inventoryPolicy === 'continue';
      const oosOnline = variantData?.stockStatus === 'Out of stock';
      const isAvailable = variant.available && (continueSelling || !oosOnline)

      return variantData ? {  ...variantData, ...variant, isAvailable } : variant;
    }

    selectCurrentVariant() {
      const selectedOptionsMatchVariant = this.selectedOptions.every((x, i) => this.variant[`option${i + 1}`] === x);

      if (!selectedOptionsMatchVariant) {
        this.optionSelectors.forEach((selector, i) => {
          const current = selector.querySelector('input:checked');

          if (current) {
            current.checked = false;
          }

          const next = selector.querySelector(`input[value="${this.variant[`option${i + 1}`]}"]`);

          if (next) {
            next.checked = true;
          }
        })
      }

      // else no change
    }
  }

  customElements.define('bundle-child-variant-picker', BundleChildVariantPicker);
}
